import { Input } from "antd";
import to from "await-to-js";
import { t } from "i18next";
import { useContext, useEffect, useState } from "react";
import { useDebouncedCallback } from "use-debounce";

import { Table } from "../../../../components/Table/Table";
import { ModalsContext } from "../../../../context/modals.context";
import { CentralRegistryContext } from "../../../../modules/ministry/centralRegistry/centralRegistry.context";
import { centralRegistryService } from "../../../../modules/ministry/centralRegistry/centralRegistry.service";
import { EvidencionaListaPosebanPostupakPayload } from "../../../../modules/ministry/centralRegistry/centralRegistry.types";
import style from "../CentralRegistry.module.scss";

const INITIAL_PARAMS = () =>
  ({
    pib: null,
    naziv: null,
  } as EvidencionaListaPosebanPostupakPayload);

export const BrandRegistrationList = () => {
  const { centralRegistry, setCentralRegistry } = useContext(
    CentralRegistryContext
  );
  const { setError } = useContext(ModalsContext);
  const [params, setParams] = useState(INITIAL_PARAMS());

  const postEvidencionaListaPosebanPostupak = useDebouncedCallback(async () => {
    const [err, res] = await to(
      centralRegistryService.postEvidencionaListaPosebanPostupak(params)
    );
    if (err || !res.success) return setError(res?.errorMessage);
    setCentralRegistry({ brandRegistrationTable: res.data });
  }, 400);

  const updateParams = (
    accessor: keyof EvidencionaListaPosebanPostupakPayload,
    value: string | null | number
  ) => {
    setParams({ ...params, [accessor]: value });
  };

  useEffect(() => {
    postEvidencionaListaPosebanPostupak();
  }, [params]);

  const colDef = [
    {
      title: t("TABLES.REDNI_BROJ_UPISA"),
      width: "280px",
      dataIndex: "redniBrojUpisa",
    },
    {
      title: t("QR_CODE.VRSTA_DUVANSKOG_PROIZVODA"),
      width: "220px",
      dataIndex: "vrstaDuvanskogProizvoda",
    },
    {
      title: t("TABLES.NAZIV_ROBNE_MARKE"),
      width: "150px",
      dataIndex: "nazivRobneMarke",
      render: (nazivRobneMarke: string) => (
        <span style={{ textTransform: "none" }}>{nazivRobneMarke}</span>
      ),
    },
    {
      title: t("TABLES.SIFRA"),
      width: "100px",
      dataIndex: "sifraRobneMarke",
    },
    {
      title: t("TABLES.BROJ_POTVRDE"),
      width: "160px",
      dataIndex: "brojPotvrdeOUpisu",
    },
    {
      title: t("TABLES.DATUM_POTVRDE"),
      width: "170px",
      dataIndex: "datumPotvrdeOUpisu",
    },
    {
      title: t("COMMON.NAZIV"),
      dataIndex: "naziv",
      width: "120px",
    },
    {
      title: t("COMMON.PIB"),
      width: "120px",
      dataIndex: "pib",
    },
  ];

  return (
    <div className={style.mainContainer}>
      <div id="brand_registration_list">
        <h2>{t("NAVIGATION.EVIDENCIONA_LISTA_MARKAMA_CELO")}</h2>
        <div className={style.buttonContainer2}>
          <Input
            name="naziv"
            allowClear
            className="w-48"
            placeholder={t("TABLES.NAZIV_ROBNE_MARKE")}
            onChange={({ target }) => updateParams("naziv", target.value)}
          />
          <Input
            name="pib"
            allowClear
            className="w-49"
            placeholder={t("PLACEHOLDERS.PIB")}
            onChange={({ target }) => updateParams("pib", target.value)}
          />
        </div>
      </div>
      <Table
        columns={colDef}
        scrollConfig={["#brand_registration_list"]}
        dataSource={centralRegistry.brandRegistrationTable}
        name="brand-registration-list-table"
      />
    </div>
  );
};
